import { departmentService } from "../../../../Api/Services/DepartmentService";
import { ACTION_NAMES, SLICE_NAMES } from "../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../constants/error";
import createGenericSlice from "../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../utils/reduxUtils/createServiceAsyncThunk";
import { IDepartmentTaskListServiceResponse, IFetchDepartmentCategoryListPaylaod } from "../../types";

export const fetchDepartmentCategoryList = createServiceAsyncThunk<
  IDepartmentTaskListServiceResponse,
  IFetchDepartmentCategoryListPaylaod
>(
  ACTION_NAMES.FETCH_DEPARTMENT_WISE_TASKS_LIST,
  ({
    page,
    size,
    departmentId,
    nodeLevel,
  }: IFetchDepartmentCategoryListPaylaod) =>
    departmentService.getDepartmentsWiseCategoryList({
      page,
      size,
      department_id: departmentId,
      node_level: nodeLevel || undefined,
    }),
  ERROR_MESSAGES.DEPARTMENT_WISE_TASKS_LIST_FETCH_FAILURE
);

const departmentCategoryListSlice = createGenericSlice<
  IDepartmentTaskListServiceResponse,
  IFetchDepartmentCategoryListPaylaod
>(SLICE_NAMES.DEPARTMENT_CATEGORY_LIST, fetchDepartmentCategoryList);

export const {
  clearError: clearDepartmentCategoryListError,
  clearSuccessMessage: clearDepartmentCategoryListSucess,
} = departmentCategoryListSlice.actions;

export default departmentCategoryListSlice.reducer;
